module.exports = __webpack_public_path__ + "static/media/brake-inspection-red.33dbdd05.svg";